/* globals define */
/*
  Purpose: Handles pushing updates to analytics
*/

import * as digitalData from 'digitalData';
import * as Localizer from 'Localizer';
import utils from '../shared/utils';

const headerAnalytics = {};
const privateMethods = {};

/**
 * Private Methods
 */

privateMethods.createStashEventObject = function _createStashEventObject(type, detail) {
  return {
    eventMode: 'stash',
    category: {
      primaryCategory: 'stash'
    },
    eventInfo: {
      eventName: type.toLowerCase()
    },
    stash: {
      clickInfo: detail.toLowerCase()
    }
  };
};

privateMethods.pushEvent = function _pushEvent(eventObject) {
  if (!headerAnalytics.loaded) {
    throw new Error('header.analytics must be initialized before it can be used.');
  }

  // Push this thing in via the API when its loaded
  return headerAnalytics.loaded.then(function _pushEventWhenLoaded() {
    headerAnalytics.digitalDataApi.event.push(eventObject);
  });
};

privateMethods.pushUser = function _pushUser(userObject) {
  if (!headerAnalytics.loaded) {
    throw new Error('header.analytics must be initialized before it can be used.');
  } else if (headerAnalytics.digitalDataApi?.user?.localization) {
    return headerAnalytics.loaded.then(function _pushUserWhenLoaded() {
      const digitalDataZip = {'userZip' : userObject};
      let digitalDataZipObj = headerAnalytics.digitalDataApi.user.localization;
      Object.assign(digitalDataZipObj, digitalDataZip);
    });
  }
};

/**
 * Public Methods
 */

headerAnalytics.getPrivateMethods = function getPrivateMethods() {
  return privateMethods;
};

headerAnalytics.logEvent = function _logEvent(type, details) {
  const eventObject = privateMethods.createStashEventObject(type, details);

  return privateMethods.pushEvent(eventObject);
};

headerAnalytics.logEventObject = function _logEvent(eventObject) {
  return privateMethods.pushEvent(eventObject);
};

headerAnalytics.cartReminder = function _cartReminder() {
  const eventObject = {
    category: {
      primaryCategory: 'overlay'
    },
    eventInfo: { eventName: 'cart reminder' }
  };
  return privateMethods.pushEvent(eventObject);
};

headerAnalytics.userAddedDeliveryZip = function _userAddedDeliveryZip(zipCode) {
  const userObject = zipCode;
  const userZipInterval = setInterval(function() {
    return privateMethods.pushUser(userObject);
  }, 1000);
  if (headerAnalytics.digitalDataApi?.user?.localization?.userZip) {
    clearInterval(userZipInterval);
  }
  setTimeout(function() {
    clearInterval(userZipInterval);
  }, 6000);
};

headerAnalytics.init = function _init() {
  if (!headerAnalytics.loaded) {
    let loadedDefer = utils.deferred();
    headerAnalytics.loaded = loadedDefer.promise();

    Localizer.localize().then(function _getApiWhenLoaded() {
      headerAnalytics.digitalDataApi = digitalData.get();
      loadedDefer.resolve();
    });
  }

  return headerAnalytics.loaded;
};

export default headerAnalytics;